import { AfterViewInit, Directive, ElementRef, HostListener, OnChanges, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
	selector: '[appPhoneMask]'
})
export class PhoneMaskDirective implements AfterViewInit, OnChanges {
	constructor(
		private el: ElementRef,
		@Optional() private control: NgControl
	) {}

	ngAfterViewInit(): void {
		this.formatCurrentValue();
		if (this.control?.valueChanges) {
			this.control.valueChanges.subscribe((value) => {
				const input = this.el.nativeElement as HTMLInputElement;
				if (value !== input.value) {
					this.formatCurrentValue();
				}
			});
		}
	}

	ngOnChanges(): void {
		this.formatCurrentValue();
	}

	@HostListener('input', ['$event'])
	onInputChange(event: Event) {
		const input = this.el.nativeElement as HTMLInputElement;
		this.applyMask(input.value);
	}

	private formatCurrentValue(): void {
		const input = this.el.nativeElement as HTMLInputElement;
		if (input.value) {
			this.applyMask(input.value);
		}
	}

	private applyMask(raw: string): void {
		const input = this.el.nativeElement as HTMLInputElement;
		let digits = raw.replace(/\D/g, '');

		if (digits.length === 11 && digits.startsWith('1')) {
			digits = digits.slice(1);
		}

		if (digits.length > 10) {
			digits = digits.substring(0, 10);
		}

		const formatted = this.formatPhoneNumber(digits);
		if (formatted !== input.value) {
			input.value = formatted;
			if (this.control?.control) {
				this.control.control.setValue(formatted, { emitEvent: false });
			}
		}
	}

	private formatPhoneNumber(value: string): string {
		if (value.length > 6) {
			return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
		} else if (value.length > 3) {
			return `(${value.slice(0, 3)}) ${value.slice(3, 6)}`;
		} else if (value.length > 0) {
			return `(${value.slice(0, 3)}`;
		} else {
			return value;
		}
	}
}
